import $ from 'jquery';
import { createApp } from 'vue';
import CompanyCards from './components/CompanyCards.vue';

$('.companies-cards-app').each((index, element) => {
	const $app = $(element);
	const locations = $app.data('locations');
	const iconPath = $app.data('icon-path');
	const translations = $app.data('translations');
	const filterUrl = $app
		.data('filter-url')
		.replace(/([&?])cHash=[^&]*(&|$)/, '$1')
		.replace(/&$/, '');
	const filterConfig = $app.data('filter-config');
	const defaultSearchZipLocation = $app.data('default-zip-search-location');

	createApp(CompanyCards, {
		locations,
		filterUrl,
		iconPath,
		translations,
		filterConfig,
		defaultSearchZipLocation,
	}).mount($app[0]);
});
